const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Assets",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.5,9.765A9.666,9.666,0,0,0,6.545,9.759a6.766,6.766,0,0,0,.779,13.488h4.833a.967.967,0,1,0,0-1.933H7.324a4.833,4.833,0,0,1,.057-9.666.967.967,0,0,0,.961-.86,7.733,7.733,0,0,1,15.363,0,1.025,1.025,0,0,0,1.018.86,4.833,4.833,0,0,1,0,9.666H19.89a.967.967,0,1,0,0,1.933h4.833A6.766,6.766,0,0,0,25.5,9.765Z",
    style: {
      fill: "#49b3b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.441,19.332a.966.966,0,0,0,1.39-1.342l-.024-.024-4.1-4.1a.967.967,0,0,0-1.367,0h0l-4.1,4.1a.966.966,0,1,0,1.343,1.39l.024-.024,2.45-2.451V29.047a.967.967,0,0,0,1.933,0V16.881Z",
    style: {
      fill: "#f2b42a"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.87f9d6a3e2292358a8d05ec4f7aa5dc6.svg";
export { ForwardRef as ReactComponent };